import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createUpdateAction } from "../../network/store/action/BranchResponseAction";
import {
  formUpdateData,
  updateFormInfo,
} from "../../redux/slice/formUpdateSlice";
import { updateMessage } from "../../redux/slice/toastSlice";

const AddUpdateForm = (props) => {
  // TO get Callbacks
  const dispatch = useDispatch();
  const formData = useSelector(formUpdateData);
  const itemInfo = formData.item;
  // // Page Form
  const [dataForm, setDataForm] = useState({
    name: "",
    address: "",
    radius: "",
    cName: "",
    cPhoneOne: "",
    cPhonetwo: "",
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    console.log("Item Info =>", itemInfo);
    if (itemInfo != undefined) {
      let updateValues = {
        name: itemInfo.name,
        address: itemInfo.address,
        radius: itemInfo.name,
        cName: itemInfo.contact_name,
        cPhoneOne: itemInfo.contact_one,
        cPhonetwo: itemInfo.contact_two,
        latitude: itemInfo.latitude,
        longitude: itemInfo.longitude,
      };
      setDataForm(updateValues);
    }
  }, []);

  const handleInputChanges = (e) => {
    if (e.target.name === "radius") {
      const selectedRadius = e.target.value.slice(0, 2);
      setDataForm({
        ...dataForm,
        [e.target.name]: selectedRadius,
      });
    } else if (e.target.name === "cPhoneOne" || e.target.name === "cPhonetwo") {
      const selected = e.target.value.slice(0, 10);
      setDataForm({
        ...dataForm,
        [e.target.name]: selected,
      });
    } else {
      setDataForm({
        ...dataForm,
        [e.target.name]: e.target.value,
      });
    }
  };

  const onSubmtClick = async () => {
    let requestBody = {
      name: dataForm.name,
      address: dataForm.address,
      latitude: dataForm.latitude,
      longitude: dataForm.longitude,
      radius: dataForm.radius,
      cName: dataForm.cName,
      phoneOne: dataForm.cPhoneOne,
      phoneTwo: dataForm.cPhonetwo,
    };

    if (itemInfo != undefined) {
      requestBody.id = itemInfo.id;
    }

    await dispatch(createUpdateAction(requestBody)).then((response) => {
      if (response.status == true) {
        if (props.onSubmit) props.onSubmit();
      } else {
        dispatch(
          updateMessage({
            display: true,
            message: "Error While updating info",
          })
        );
      }
    });
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          backgroundColor: "rgba(0,0,0,0.5)",
          width: "100%",
          height: "100%",
          zIndex: "999",
          overflow: "scroll",
        }}
      >
        <div className="d-flex align-item-center justify-content-center">
          <div className="col-md-8">
            <div className="container">
              <div className="row mt-5">
                <div className="col-md-5 card-1 p-5">
                  {itemInfo != undefined ? (
                    <h4 className="text-center">Update Branch</h4>
                  ) : (
                    <h4 className="text-center"> Add Branch</h4>
                  )}

                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Branch Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={dataForm.name}
                        onChange={(e) => handleInputChanges(e)}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Branch Address</label>
                      <textarea
                        type="text"
                        name="address"
                        className="form-control"
                        value={dataForm.address}
                        onChange={(e) => handleInputChanges(e)}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Serving Radius</label>
                      <input
                        type="number"
                        name="radius"
                        maxLength="2"
                        className="form-control"
                        value={dataForm.radius}
                        onChange={(e) => handleInputChanges(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Contact Name</label>
                      <input
                        type="text"
                        name="cName"
                        className="form-control"
                        value={dataForm.cName}
                        onChange={(e) => handleInputChanges(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Contact Phone</label>
                      <input
                        maxLength="10"
                        type="number"
                        name="cPhoneOne"
                        className="form-control"
                        value={dataForm.cPhoneOne}
                        onChange={(e) => handleInputChanges(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Alternate Contact Number</label>
                      <input
                        maxLength="10"
                        type="number"
                        name="cPhonetwo"
                        className="form-control"
                        value={dataForm.cPhonetwo}
                        onChange={(e) => handleInputChanges(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Latitude</label>
                      <input
                        type="number"
                        name="latitude"
                        className="form-control"
                        value={dataForm.latitude}
                        onChange={(e) => handleInputChanges(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>Longitude</label>
                      <input
                        type="number"
                        name="longitude"
                        className="form-control"
                        value={dataForm.longitude}
                        onChange={(e) => handleInputChanges(e)}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: 20,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      style={{ display: "flex", justifyContent: "center" }}
                      type="button"
                      className="btn btn-purple-bg"
                      onClick={() => onSubmtClick()}
                    >
                      Submit
                    </button>
                    <button
                      className="btn btn-white-bg"
                      onClick={() => {
                        dispatch(
                          updateFormInfo({
                            displayForm: false,
                            formData: {},
                          })
                        );
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUpdateForm;
